import * as yup from 'yup';

export const validationSchema = yup.object({
  cddid: yup
    .string()
    .required(),
});
